import './ThumbnailComponent.scss'
import React, {useEffect, useState} from 'react';
import {Cancel} from "@mui/icons-material";

interface ThumbnailComponentProps {
    attachmentFile?: File;
    attachmentUrl?: string;
    attachmentType?: string;
    height?: number;
    width?: number;
    isFile?: boolean;
    onClose?: Function;
}

const ThumbnailComponent = (props: ThumbnailComponentProps) => {

        const {attachmentFile, attachmentUrl, isFile, width, height, onClose} = props;

        const [attachmentPreviewUrl, setAttachmentPreviewUrl] = useState<any>();

        useEffect(() => {
            if (isFile) {
                if (!attachmentFile) {
                    setAttachmentPreviewUrl(undefined)
                    return;
                }
                const reader = new FileReader();
                reader.onloadend = () => {
                    setAttachmentPreviewUrl(reader.result);
                };
                if (attachmentFile) {
                    reader.readAsDataURL(attachmentFile);
                    setAttachmentPreviewUrl(reader.result);
                } else {
                    setAttachmentPreviewUrl("");
                }
            } else {
                if (attachmentUrl) {
                    setAttachmentPreviewUrl(attachmentUrl);
                }
            }
        }, [attachmentFile, attachmentUrl, isFile]);

        return (
            <div className="thumb-nail-wrapper component">
                {attachmentPreviewUrl &&
                    <>
                    <span className="thumb-nail-item-close"
                          onClick={() => {
                              if (onClose) {
                                  onClose();
                              }
                          }}
                    >
                    <Cancel/>
                </span>
                        <div className="thumb-nail-item">
                            <img src={attachmentPreviewUrl}
                                 alt={'attachment'}
                                 width={width}
                                 height={height}
                            />
                        </div>
                    </>
                }
            </div>
        );
    }

;

export default ThumbnailComponent;